import { render } from "./actionmodalwide.vue?vue&type=template&id=0af2a3aa&scoped=true"
import script from "./actionmodalwide.vue?vue&type=script&lang=js"
export * from "./actionmodalwide.vue?vue&type=script&lang=js"

import "./actionmodalwide.vue?vue&type=style&index=0&id=0af2a3aa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0af2a3aa"]])

export default __exports__